import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/workplace-xg/workplace-xg/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import ImageCollection from "../../../components/ImageCollection";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Column = makeShortcode("Column");
const Caption = makeShortcode("Caption");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`The use of different ceiling systems and materials help define IBM workplace zones. The options available for ceilings can work to create identifiable moods for a zone. Each option also subtly signals expected behaviors for each zone, creating a cohesive experience for clients and employees.`}</p>
    </PageDescription>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Wood ceiling</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Felt ceiling</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Open ceiling</AnchorLink>
    </AnchorLinks>
    <h2>{`Wood ceiling`}</h2>
    <p>{`The use of specialty wood ceiling systems creates a warm and welcoming space for IBM employees and guests. Wood communicates growth and stability. When used as a ceiling material, placement matters. It’s important that the pattern is linear. Learn more about the `}<a parentName="p" {...{
        "href": "/workplace-xg/space-types/arrival"
      }}>{`Arrival`}</a>{`, `}<a parentName="p" {...{
        "href": "/workplace-xg/space-types/welcome"
      }}>{`Welcome`}</a>{` and `}<a parentName="p" {...{
        "href": "/workplace-xg/space-types/connect"
      }}>{`Connect`}</a>{` zones.`}</p>
    <ImageCollection mdxType="ImageCollection">
      <Column colLg={8} colMd={5} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAEEAgP/xAAVAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAABy1XFSHQT/8QAGRAAAgMBAAAAAAAAAAAAAAAAAAECESED/9oACAEBAAEFAlCxc2NUaSjjP//EABYRAAMAAAAAAAAAAAAAAAAAAAEQEf/aAAgBAwEBPwGlf//EABYRAAMAAAAAAAAAAAAAAAAAAAEQEf/aAAgBAgEBPwGBf//EABgQAAMBAQAAAAAAAAAAAAAAAAABIRAi/9oACAEBAAY/AuWnsEU//8QAGxAAAwADAQEAAAAAAAAAAAAAAAEhETFxQWH/2gAIAQEAAT8hdaQR250U0Wejejv5kgWCPxT/2gAMAwEAAgADAAAAEK//AP/EABcRAQEBAQAAAAAAAAAAAAAAAAEAETH/2gAIAQMBAT8QW7a3/8QAFhEBAQEAAAAAAAAAAAAAAAAAAQAR/9oACAECAQE/EArC/8QAGxABAQEAAwEBAAAAAAAAAAAAAREAITFBceH/2gAIAQEAAT8QAYBWMZ81VDgA8vVxchS3J7AJUDoAKZ0nc/cpOIHjv//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Wood ceiling",
            "title": "Wood ceiling",
            "src": "/workplace-xg/static/88e347be9691520b0508864a42842dbb/2e753/wood-ceiling.jpg",
            "srcSet": ["/workplace-xg/static/88e347be9691520b0508864a42842dbb/69549/wood-ceiling.jpg 288w", "/workplace-xg/static/88e347be9691520b0508864a42842dbb/473e3/wood-ceiling.jpg 576w", "/workplace-xg/static/88e347be9691520b0508864a42842dbb/2e753/wood-ceiling.jpg 1152w", "/workplace-xg/static/88e347be9691520b0508864a42842dbb/a052a/wood-ceiling.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  Coffered ceilings reinforce the 2x Grid while adding a sense of warmth.
        </Caption>
      </Column>
      <Column colLg={4} colMd={3} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "133.33333333333331%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAbABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAQBAgMF/8QAFgEBAQEAAAAAAAAAAAAAAAAAAAIB/9oADAMBAAIQAxAAAAHk2bdKmwxLadJpIqH/xAAeEAACAQMFAAAAAAAAAAAAAAABAgMAEBIEESEiMv/aAAgBAQABBQIWQYrAmRwjNF0StPwU3CTv3W0/v//EABcRAQADAAAAAAAAAAAAAAAAAAAQERL/2gAIAQMBAT8BjKn/xAAYEQACAwAAAAAAAAAAAAAAAAAAEQECEP/aAAgBAgEBPwFZNhn/xAAbEAADAAIDAAAAAAAAAAAAAAAAAREQgQIiQf/aAAgBAQAGPwLEFUdPCNipzpoeNH//xAAbEAEAAwEBAQEAAAAAAAAAAAABABEhMUFhcf/aAAgBAQABPyHNkraJSDyBXdu4MsC/ERzPZrY6RYEzIwM8QlKuNEeP5NG4/9oADAMBAAIAAwAAABDkHnL/xAAVEQEBAAAAAAAAAAAAAAAAAAABEP/aAAgBAwEBPxAYBj//xAAWEQEBAQAAAAAAAAAAAAAAAAAAARH/2gAIAQIBAT8QpqsR/8QAHBABAQEBAQEAAwAAAAAAAAAAAREAIUFRMWGx/9oACAEBAAE/EIQ2DSnmpAVWBouWOp99316BKL3s8wFwFsx8ceC5xF/hqegLNsek0FotNG8fmBxfq3MlCB+DEOWGzpjf/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "wood slat ceiling in elevator lobby",
            "title": "wood slat ceiling in elevator lobby",
            "src": "/workplace-xg/static/78068c543e660e7af7ff1630bbce7bd8/473e3/wood-slat-ceiling-in-elevator-lobby.jpg",
            "srcSet": ["/workplace-xg/static/78068c543e660e7af7ff1630bbce7bd8/69549/wood-slat-ceiling-in-elevator-lobby.jpg 288w", "/workplace-xg/static/78068c543e660e7af7ff1630bbce7bd8/473e3/wood-slat-ceiling-in-elevator-lobby.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Linear placement guides the flow to elevators.</Caption>
      </Column>
      <Column colLg={4} colMd={3} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAAQF/8QAFwEAAwEAAAAAAAAAAAAAAAAAAQIDAP/aAAwDAQACEAMQAAABRa2fKk6gNdEERh1//8QAHBAAAgICAwAAAAAAAAAAAAAAAAECAxIxESEi/9oACAEBAAEFAr1ysEYRLF5WuiyTJayZ/8QAFREBAQAAAAAAAAAAAAAAAAAAASD/2gAIAQMBAT8BI//EABYRAAMAAAAAAAAAAAAAAAAAAAERIP/aAAgBAgEBPwEuP//EABoQAAICAwAAAAAAAAAAAAAAAAABAjERIHH/2gAIAQEABj8CSZRRLKH3X//EABsQAAICAwEAAAAAAAAAAAAAAAABESExQWEQ/9oACAEBAAE/IVqErJvfjT0MdGWDAVBhORZbW6Oh/9oADAMBAAIAAwAAABDj/wDD/8QAGhEAAgIDAAAAAAAAAAAAAAAAAAERITFBUf/aAAgBAwEBPxBlGCuGiWf/xAAZEQADAAMAAAAAAAAAAAAAAAAAASERUWH/2gAIAQIBAT8Q7F2Kswj/xAAdEAEBAQACAgMAAAAAAAAAAAABEQAhMUGRYXHw/9oACAEBAAE/EIKSw+szhDxbmvT05KCcFp/c5YeAC/TqCmGkI9kxOORw+WI99//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "wood slat ceiling",
            "title": "wood slat ceiling",
            "src": "/workplace-xg/static/a115fd514f833dfc3a2536b2bdbf1de1/473e3/wood-slat-ceiling.jpg",
            "srcSet": ["/workplace-xg/static/a115fd514f833dfc3a2536b2bdbf1de1/69549/wood-slat-ceiling.jpg 288w", "/workplace-xg/static/a115fd514f833dfc3a2536b2bdbf1de1/473e3/wood-slat-ceiling.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
      <Column colLg={8} colMd={5} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAABAAD/8QAFQEBAQAAAAAAAAAAAAAAAAAAAgP/2gAMAwEAAhADEAAAAcEm3m0xpH//xAAYEAADAQEAAAAAAAAAAAAAAAAAARMCEv/aAAgBAQABBQLAkRZnlFCp/8QAFhEBAQEAAAAAAAAAAAAAAAAAABES/9oACAEDAQE/AdK//8QAFhEBAQEAAAAAAAAAAAAAAAAAABEB/9oACAECAQE/AYmP/8QAGBAAAgMAAAAAAAAAAAAAAAAAACAhInH/2gAIAQEABj8CtBq//8QAHBABAAIDAQEBAAAAAAAAAAAAAQARITFBYYHw/9oACAEBAAE/IXemmxshtUeIIbD7PS4rLyc4MclvzP/aAAwDAQACAAMAAAAQ6+//xAAWEQADAAAAAAAAAAAAAAAAAAAAEVH/2gAIAQMBAT8Qaj0//8QAGBEAAgMAAAAAAAAAAAAAAAAAABFRYbH/2gAIAQIBAT8QWNKD/8QAHhABAAMAAgIDAAAAAAAAAAAAAQARITFRQWGB0eH/2gAIAQEAAT8QGoqbHhF7WkVqLi271LA+oQwFF0tR6cZMXHF+NqKcKfP6n//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "wood slat ceiling to mark collaboration space",
            "title": "wood slat ceiling to mark collaboration space",
            "src": "/workplace-xg/static/b3d21e54f5252a88ae519adc8d0f4343/2e753/wood-slat-ceiling-to-mark-collaboration-space.jpg",
            "srcSet": ["/workplace-xg/static/b3d21e54f5252a88ae519adc8d0f4343/69549/wood-slat-ceiling-to-mark-collaboration-space.jpg 288w", "/workplace-xg/static/b3d21e54f5252a88ae519adc8d0f4343/473e3/wood-slat-ceiling-to-mark-collaboration-space.jpg 576w", "/workplace-xg/static/b3d21e54f5252a88ae519adc8d0f4343/2e753/wood-slat-ceiling-to-mark-collaboration-space.jpg 1152w", "/workplace-xg/static/b3d21e54f5252a88ae519adc8d0f4343/a052a/wood-slat-ceiling-to-mark-collaboration-space.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </ImageCollection>
    <h2>{`Felt ceiling`}</h2>
    <p>{`The use of specialty felt ceiling systems in tonal grays creates an energetic and fun atmosphere. This material is perfect for gathering spaces, such a casual dining and refreshment areas. Felt can also be used effectively in Collaborate, Focus and Play zones. Learn more about `}<a parentName="p" {...{
        "href": "/workplace-xg/space-types/collaborate"
      }}>{`Collaborate`}</a>{`, `}<a parentName="p" {...{
        "href": "/workplace-xg/space-types/focus"
      }}>{`Focus`}</a>{` and `}<a parentName="p" {...{
        "href": "/workplace-xg/space-types/play"
      }}>{`Play`}</a>{` zones.`}</p>
    <ImageCollection mdxType="ImageCollection">
      <Column colLg={8} colMd={5} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAABAAD/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAcTMVYG3j//EABwQAAAGAwAAAAAAAAAAAAAAAAABAgMRFAQSMv/aAAgBAQABBQKs2FY8HVUNChsL7//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABwQAAIABwAAAAAAAAAAAAAAAAABAhARIjJBkf/aAAgBAQAGPwLKItq0a6KTP//EABwQAQACAgMBAAAAAAAAAAAAAAEAESFhMUGRUf/aAAgBAQABPyFqvZxNCmU+wqyl3ANA+sJVdEPpP//aAAwDAQACAAMAAAAQxM//xAAVEQEBAAAAAAAAAAAAAAAAAAAQIf/aAAgBAwEBPxCn/8QAFREBAQAAAAAAAAAAAAAAAAAAECH/2gAIAQIBAT8Qh//EABwQAQADAAMBAQAAAAAAAAAAAAEAESExQZFxwf/aAAgBAQABPxBZpiarxj+kzCEsIt4AE462JqeDGQFInU+ylZdCXu/YYJYWwU7n/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "felt ceiling",
            "title": "felt ceiling",
            "src": "/workplace-xg/static/17b3af7dab11fc57aa8f4907d9f99a47/2e753/felt-ceiling.jpg",
            "srcSet": ["/workplace-xg/static/17b3af7dab11fc57aa8f4907d9f99a47/69549/felt-ceiling.jpg 288w", "/workplace-xg/static/17b3af7dab11fc57aa8f4907d9f99a47/473e3/felt-ceiling.jpg 576w", "/workplace-xg/static/17b3af7dab11fc57aa8f4907d9f99a47/2e753/felt-ceiling.jpg 1152w", "/workplace-xg/static/17b3af7dab11fc57aa8f4907d9f99a47/a052a/felt-ceiling.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  Felt ceilings help absorb ambient noise in the relaxed atmosphere of a Connect
  zone.
        </Caption>
      </Column>
      <Column colLg={4} colMd={3} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAQCAwX/xAAWAQEBAQAAAAAAAAAAAAAAAAABAAL/2gAMAwEAAhADEAAAAe+K5xylRZgnyA5//8QAHRAAAgIBBQAAAAAAAAAAAAAAAQIAAxIREyEiQf/aAAgBAQABBQJk1Crzu1iZy18QLFiMSr9h7//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8BH//EABYRAQEBAAAAAAAAAAAAAAAAABEAEP/aAAgBAgEBPwFnf//EABoQAQADAAMAAAAAAAAAAAAAAAABESESMTL/2gAIAQEABj8CarlDyunSGpf/xAAbEAEBAQACAwAAAAAAAAAAAAABEQAhMUFhwf/aAAgBAQABPyHqRuhXHLlEmlvLJ9XJtduQHdfwmWB73//aAAwDAQACAAMAAAAQgBgD/8QAGBEAAgMAAAAAAAAAAAAAAAAAABEBEFH/2gAIAQMBAT8QQo2//8QAGBEAAgMAAAAAAAAAAAAAAAAAAAEQEVH/2gAIAQIBAT8QbFsFH//EABwQAQEAAwEAAwAAAAAAAAAAAAERACFBMWFxkf/aAAgBAQABPxBYIHmv3Kgp9ie4zMIjdZNETqm8Vz4xNj9YYlJLoe45gpNz4cNnUEJzWIQ6Fn//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "felt ceiling system over collaboration space",
            "title": "felt ceiling system over collaboration space",
            "src": "/workplace-xg/static/26880b4277f0c57bf12e6cd039e07a60/473e3/felt-ceiling-system-over-collaboration-space.jpg",
            "srcSet": ["/workplace-xg/static/26880b4277f0c57bf12e6cd039e07a60/69549/felt-ceiling-system-over-collaboration-space.jpg 288w", "/workplace-xg/static/26880b4277f0c57bf12e6cd039e07a60/473e3/felt-ceiling-system-over-collaboration-space.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </ImageCollection>
    <h2>{`Open ceiling`}</h2>
    <p>{`Open ceilings create the sensation of more space and volume so, work well in open workplaces that can have larger groups. They help define the intent of the space and can be considered for `}<a parentName="p" {...{
        "href": "/workplace-xg/space-types/collaborate"
      }}>{`Collaborate`}</a>{` and `}<a parentName="p" {...{
        "href": "/workplace-xg/space-types/play"
      }}>{`Play`}</a>{` zones.`}</p>
    <ImageCollection mdxType="ImageCollection">
      <Column colLg={8} colMd={5} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "125%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAZABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAQDAgX/xAAWAQEBAQAAAAAAAAAAAAAAAAAAAQL/2gAMAwEAAhADEAAAAUe00eogFTlNapFz/8QAGxAAAgMBAQEAAAAAAAAAAAAAAQMAAhIyBBP/2gAIAQEAAQUCbbCKPguCPRzVOp8KwmLOoW5g6V0zv//EABYRAQEBAAAAAAAAAAAAAAAAAAABEP/aAAgBAwEBPwHIr//EABYRAQEBAAAAAAAAAAAAAAAAAAABEf/aAAgBAgEBPwFqo//EAB4QAAIBAwUAAAAAAAAAAAAAAAABEQIhMRBBUXGR/9oACAEBAAY/AnzsRX6ZkSL2M1Dg6I0qGf/EAB8QAQABAwQDAAAAAAAAAAAAAAEAESFBMVFhsRBxof/aAAgBAQABPyFLlwUc6GJWABuS8RmrFvVOCcD6Im89wU2R1DKm3Tia0+I8b//aAAwDAQACAAMAAAAQ3z0P/8QAFxEBAQEBAAAAAAAAAAAAAAAAAQAxEf/aAAgBAwEBPxAFy42rV//EABgRAAMBAQAAAAAAAAAAAAAAAAABMRAR/9oACAECAQE/EG+YghH/xAAhEAEAAgEEAQUAAAAAAAAAAAABABEhMVGRsUFxodHw8f/aAAgBAQABPxCsyaA1G/2Vo4XBcq+J4soJYy7gl6BxWO2FK6MBa+u0pDKrNCLuMHXRll0QPAiqGGa38uuZ259Fsz2h0T//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "open ceiling with exposed beams and painted duct work",
            "title": "open ceiling with exposed beams and painted duct work",
            "src": "/workplace-xg/static/0fcdbec829702837b230e59136459746/2e753/open-ceiling-with-exposed-beams-and-painted-duct-work.jpg",
            "srcSet": ["/workplace-xg/static/0fcdbec829702837b230e59136459746/69549/open-ceiling-with-exposed-beams-and-painted-duct-work.jpg 288w", "/workplace-xg/static/0fcdbec829702837b230e59136459746/473e3/open-ceiling-with-exposed-beams-and-painted-duct-work.jpg 576w", "/workplace-xg/static/0fcdbec829702837b230e59136459746/2e753/open-ceiling-with-exposed-beams-and-painted-duct-work.jpg 1152w", "/workplace-xg/static/0fcdbec829702837b230e59136459746/a052a/open-ceiling-with-exposed-beams-and-painted-duct-work.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  A lowered ceiling helps define the appearance of special areas.
        </Caption>
      </Column>
      <Column colLg={4} colMd={3} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "151.04166666666669%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAQBAgYD/8QAFgEBAQEAAAAAAAAAAAAAAAAAAQAC/9oADAMBAAIQAxAAAAFGmhjLljQiU5vTSQ0R/8QAGxAAAwADAQEAAAAAAAAAAAAAAAECAxESBCL/2gAIAQEAAQUCryWh4+YSTJKaNJnRke5xz8LHJzJs/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFREBAQAAAAAAAAAAAAAAAAAAICH/2gAIAQIBAT8Bo//EABwQAAMAAgMBAAAAAAAAAAAAAAABIQIQEjFBcf/aAAgBAQAGPwKNMuOfL5CzdpUVMR6da//EAB0QAQACAwADAQAAAAAAAAAAAAEAESExQVFhceH/2gAIAQEAAT8h04R8cH1AmSvE0G6auA6Htm2heQl+h6WHRmaqYPVEAZtjrEOYYfk//9oADAMBAAIAAwAAABALJ7H/xAAXEQEBAQEAAAAAAAAAAAAAAAAAESEB/9oACAEDAQE/EMXjEf/EABcRAQEBAQAAAAAAAAAAAAAAAAABEYH/2gAIAQIBAT8QMquv/8QAHhABAQACAQUBAAAAAAAAAAAAAREAITFBUXGx8GH/2gAIAQEAAT8QrJfbGM8YZgDqGfI6MaNVIFxI+1qdPzAdPQeSqdj7eBB87A9YWWjJ6GGQegXT3zRniwT4wA0tbcNYGjcxYCEJwc//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "open ceiling",
            "title": "open ceiling",
            "src": "/workplace-xg/static/8bedb1d64a52fbc6e15c1f5c4683756b/473e3/open-ceiling.jpg",
            "srcSet": ["/workplace-xg/static/8bedb1d64a52fbc6e15c1f5c4683756b/69549/open-ceiling.jpg 288w", "/workplace-xg/static/8bedb1d64a52fbc6e15c1f5c4683756b/473e3/open-ceiling.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
      <Column colLg={4} colMd={3} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAAMBAAAAAAAAAAAAAAAAAAECBAP/xAAVAQEBAAAAAAAAAAAAAAAAAAABAP/aAAwDAQACEAMQAAAB20ipHNVdIOQJ/8QAGRAAAwEBAQAAAAAAAAAAAAAAAAECERIh/9oACAEBAAEFAmM6R1NNaylE0vIplvb/AP/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8BH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8BH//EABwQAAICAgMAAAAAAAAAAAAAAAABAhEhMRAiwf/aAAgBAQAGPwLXGy4yeDu3krwoTGf/xAAeEAACAgICAwAAAAAAAAAAAAAAAREhMUFRgWFxsf/aAAgBAQABPyG90E5IdF7JSgdCMVBqSWhwRJLsYrEQUbFSJA/Hw//aAAwDAQACAAMAAAAQ/wD/AMH/xAAVEQEBAAAAAAAAAAAAAAAAAAAQQf/aAAgBAwEBPxAp/8QAFREBAQAAAAAAAAAAAAAAAAAAEEH/2gAIAQIBAT8QIf/EACAQAQACAgIBBQAAAAAAAAAAAAEAESExQVFhgZGh0eH/2gAIAQEAAT8QFgbKvcYAFYy9BzHFr7BZTuX2OcaZT763KW1GpWnL6MN+qoQ8g5UZWiB2njOPmMGAU8An5EAi/RP/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "open ceiling system in collaboration space",
            "title": "open ceiling system in collaboration space",
            "src": "/workplace-xg/static/09edb6b878f97683d07531700fc515d0/473e3/open-ceiling-system-in-collaboration-space.jpg",
            "srcSet": ["/workplace-xg/static/09edb6b878f97683d07531700fc515d0/69549/open-ceiling-system-in-collaboration-space.jpg 288w", "/workplace-xg/static/09edb6b878f97683d07531700fc515d0/473e3/open-ceiling-system-in-collaboration-space.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
      <Column colLg={8} colMd={5} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAABAABA//EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAFHIuwuPH//xAAaEAACAwEBAAAAAAAAAAAAAAAAAgEREhMh/9oACAEBAAEFAqVTBxkZp3v2Ho//xAAVEQEBAAAAAAAAAAAAAAAAAAAAEf/aAAgBAwEBPwFX/8QAFREBAQAAAAAAAAAAAAAAAAAAABH/2gAIAQIBAT8BiP/EABkQAAIDAQAAAAAAAAAAAAAAAAABEBEhof/aAAgBAQAGPwLejMpih0f/xAAZEAEAAwEBAAAAAAAAAAAAAAABABEhMUH/2gAIAQEAAT8hcQFrIbug9lnYR9zgwCEvOR9nW+T/2gAMAwEAAgADAAAAEMQf/8QAFhEBAQEAAAAAAAAAAAAAAAAAAQAR/9oACAEDAQE/EBctX//EABYRAAMAAAAAAAAAAAAAAAAAAAABEf/aAAgBAgEBPxBpST//xAAaEAEBAAMBAQAAAAAAAAAAAAABEQAhQaEx/9oACAEBAAE/EEHYClAswYlBoWJeZQx2lEI9NuIaDFvuQadrPM+eLuh25//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "open ceiling with pendant lighting over work space",
            "title": "open ceiling with pendant lighting over work space",
            "src": "/workplace-xg/static/688a4cc25b5c6cb314b1c3eeae876def/2e753/open-ceiling-with-pendant-lighting-over-work-space.jpg",
            "srcSet": ["/workplace-xg/static/688a4cc25b5c6cb314b1c3eeae876def/69549/open-ceiling-with-pendant-lighting-over-work-space.jpg 288w", "/workplace-xg/static/688a4cc25b5c6cb314b1c3eeae876def/473e3/open-ceiling-with-pendant-lighting-over-work-space.jpg 576w", "/workplace-xg/static/688a4cc25b5c6cb314b1c3eeae876def/2e753/open-ceiling-with-pendant-lighting-over-work-space.jpg 1152w", "/workplace-xg/static/688a4cc25b5c6cb314b1c3eeae876def/a052a/open-ceiling-with-pendant-lighting-over-work-space.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  Refined lowered panels contrast sharply with the raw energy of an open
  ceiling.
        </Caption>
      </Column>
    </ImageCollection>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      